export default __webpack_public_path__ + "static/media/Black.ab6dfb25.png";